module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"poLineItemsList":{"checkboxTitle":"Tick/Untick the line item | Tick/Untick all line items","sortIconTitle":"Click to sort","itemNumberHeaderText":"Item #","statusHeaderText":"Status","noLineItemsText":"No Line Items found"}}}')
  delete Component.options._Ctor
}
